import ApiHelperService from '../ApiHelperService';

const webAppBaseUrl = process.env.REACT_APP_WEBAPP_API_BASE_URL

// changes ${baseurl}${apiVersion}
const post = (endpoint, payload, headers, options = {}) => {
    return ApiHelperService.post(`${webAppBaseUrl}${endpoint}`, payload, headers, options);
};
export default {
    post  
};
